var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99821 17.478C8.99805 17.4779 8.99789 17.4778 8.99774 17.4777C8.93231 17.4382 8.8406 17.3692 8.72254 17.2628C8.48761 17.051 8.19364 16.7324 7.85815 16.3242C7.18964 15.5109 6.3932 14.3874 5.62745 13.1696C4.8619 11.9522 4.1349 10.6532 3.60128 9.49087C3.05653 8.30424 2.75 7.33618 2.75 6.75C2.75 3.29845 5.54845 0.5 9 0.5C12.4515 0.5 15.25 3.29845 15.25 6.75C15.25 7.32568 14.9432 8.28813 14.3966 9.47404C13.8615 10.6349 13.1327 11.9354 12.366 13.1554C11.599 14.3757 10.8018 15.5032 10.1337 16.3198C9.79851 16.7296 9.505 17.0497 9.27085 17.2626C9.15386 17.369 9.06301 17.4382 8.99821 17.478ZM7.8125 6.75C7.8125 6.09408 8.34408 5.5625 9 5.5625C9.65592 5.5625 10.1875 6.09408 10.1875 6.75C10.1875 7.40592 9.65592 7.9375 9 7.9375C8.34408 7.9375 7.8125 7.40592 7.8125 6.75ZM5.6875 6.75C5.6875 8.57983 7.17086 10.0625 9 10.0625C10.8291 10.0625 12.3125 8.57983 12.3125 6.75C12.3125 4.92017 10.8291 3.4375 9 3.4375C7.17086 3.4375 5.6875 4.92017 5.6875 6.75Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1c1ad9bca945b70b196ffc5bc441575a.svg";
export { ForwardRef as ReactComponent };